import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import type { Product } from '@/types'

const MAX_RECENT = 15

interface RecentProductsState {
  recentProducts: Product[]
  pushRecentProduct: (product: Product) => void
  clearRecentProducts: () => void
}

// Per-session ring buffer of products the cashier has opened in the
// product modal. Persisted to sessionStorage so a refresh keeps the
// list, but a sign-out / new tab starts clean — the history is the
// cashier's working memory, not a per-customer record.
export const useRecentProductsStore = create<RecentProductsState>()(
  persist(
    (set) => ({
      recentProducts: [],

      pushRecentProduct: (product) => {
        if (!product?.id) return
        set((state) => {
          const filtered = state.recentProducts.filter((p) => p.id !== product.id)
          return { recentProducts: [product, ...filtered].slice(0, MAX_RECENT) }
        })
      },

      clearRecentProducts: () => set({ recentProducts: [] }),
    }),
    {
      name: 'waio-pos-recent-products',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
